// reset account
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { BaseInput } from "@/components/common/BaseInputV2";
import styles from "./index.module.scss";
import { NewBaseButton } from "@/components/common/NewBaseButton";
import { useRef, useState } from "react";
import { RegisterApi } from "@/service/register";
import classNames from "classnames";
import { usePopups } from "@/store/popups";
import { useUserCreate } from "@/store/User";
import { codeVerify, emailVerify, passwordVerify } from "../../util";
import ToastV2 from "@/components/common/BaseToast";
import { useTranslations } from "next-intl";
export const GLOBAL_COUNTDOWN = 60;
export const ResetPage = props => {
  const {
    data,
    changeAccountData
  } = props;
  const t = useTranslations();
  const [verifyPdText, setVerifyPdText] = useState("");
  const [verifyCodeText, setVerifyCodeText] = useState("");
  const [verifyEmailText, setVerifyEmailText] = useState("");
  const [needVerify, setNeedVerify] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [restTime, setRestTime] = useState(0);
  const timerRef = useRef(null);
  const popupDispatch = usePopups(state => state.dispatch);
  const userDispatch = useUserCreate(state => state.dispatch);
  const inputChangeHandle = (e, type) => {
    changeAccountData({
      [type]: e.target.value
    });
  };
  const resendVerify = () => {
    if (timerRef.current || !data.email) return;
    setRestTime(GLOBAL_COUNTDOWN);
    setTimeout(() => {
      setIntervalTimeHandle();
    }, 0);
    RegisterApi.getEmailVerify(data.email, "reset").then(res => {
      if (res.code === 0) {
        return;
      } else {
        timerRef.current && clearInterval(timerRef.current);
        timerRef.current = null;
        setRestTime(0);
        ToastV2.info(res.msg);
      }
    });
  };
  const setIntervalTimeHandle = () => {
    timerRef.current = setInterval(() => {
      setRestTime(prev => {
        if (prev <= 0 && timerRef.current) {
          clearInterval(timerRef.current);
          timerRef.current = null;
          return prev;
        } else {
          return prev - 1;
        }
      });
    }, 1000);
  };
  const SendCode = () => {
    return /*#__PURE__*/_jsx("span", {
      className: classNames({
        [styles.resend_btn]: true,
        [styles.rest_num]: restTime > 0
      }),
      onClick: resendVerify,
      children: restTime == 0 ? t("Login_SendCode_Action") : "".concat(restTime, "s")
    });
  };
  const resetAccountHandle = async () => {
    setNeedVerify(true);
    if (verifyPdText || verifyEmailText || verifyCodeText || isLoading) return;
    setIsLoading(true);
    //重置密码请求
    await RegisterApi.resetAccountRequest({
      type: "email",
      ...data
    }).then(res => {
      if (res.code === 0) {
        ToastV2.success("Reset password succeeded");
        userDispatch({
          type: "updateUserInfo",
          payload: res.data
        });
        popupDispatch({
          type: "closeStack"
        });
      } else {
        ToastV2.error(res.msg);
      }
    });
    setIsLoading(false);
  };
  const verifyCodeHandle = v => {
    const {
      isVerify,
      verifyText
    } = codeVerify(v, t);
    setVerifyCodeText(verifyText);
    return needVerify ? isVerify : true;
  };
  const verifyEmailHandle = v => {
    const {
      isVerify,
      verifyText
    } = emailVerify(v, t);
    setVerifyEmailText(verifyText);
    return needVerify ? isVerify : true;
  };
  const verifyPasswordHandle = v => {
    const {
      isVerify,
      verifyText
    } = passwordVerify(v, t);
    setVerifyPdText(verifyText);
    return needVerify ? isVerify : true;
  };
  return /*#__PURE__*/_jsxs("div", {
    className: styles.reset_container,
    children: [/*#__PURE__*/_jsx("div", {
      className: styles.title,
      children: t("Login_ForgotPassword_Action")
    }), /*#__PURE__*/_jsxs("div", {
      className: styles.form_body,
      children: [/*#__PURE__*/_jsx(BaseInput, {
        value: data.email,
        onChange: e => {
          inputChangeHandle(e, "email");
        },
        placeholder: t("Login_Email_Placeholder"),
        suffix: /*#__PURE__*/_jsx(SendCode, {}),
        verifyText: needVerify ? verifyEmailText : "",
        verifyFn: verifyEmailHandle,
        maxLength: 40
      }), /*#__PURE__*/_jsx(BaseInput, {
        value: data.code,
        onChange: e => {
          inputChangeHandle(e, "code");
        },
        placeholder: t("Login_ActivationCode_Placeholder"),
        verifyText: needVerify ? verifyCodeText : "",
        verifyFn: verifyCodeHandle,
        maxLength: 20
      }), /*#__PURE__*/_jsx(BaseInput, {
        value: data.password,
        onChange: e => {
          inputChangeHandle(e, "password");
        },
        placeholder: t("Login_New_password_Placeholder"),
        // placeholder="New password"
        verifyText: needVerify ? verifyPdText : "",
        verifyFn: verifyPasswordHandle,
        maxLength: 40
      }), /*#__PURE__*/_jsx(NewBaseButton, {
        size: "huge",
        block: true,
        onClick: resetAccountHandle,
        loading: isLoading,
        children: t("Login_Password_login_Aciton")
      })]
    })]
  });
};